import React from "react";

const Footer = () => {
  return (
    <footer
      style={{
        width: "100%",
        background: "#f8f9fb",
        padding: "40px 20px",
        borderTop: "1px solid #ddd",
        marginTop: "40px",
      }}
    >
      <div
        style={{
          maxWidth: "1000px",
          margin: "0 auto",
          display: "grid",
          gridTemplateColumns: "1fr",
          gap: "30px",
          textAlign: "left",

          /* Responsive */
          ...(window.innerWidth > 768 && {
            gridTemplateColumns: "1fr 1fr 1fr",
          }),
        }}
      >
        {/* Column 1 */}
        <div style={{ textAlign: "center" }}>
          <a href="/" target="_blank" rel="noopener noreferrer">
            <img
              src="https://static.wixstatic.com/media/5715af_a286bfb446374a96877a4193a1ef0933~mv2.png"
              alt="PAT Logo"
              style={{ width: "120px", marginBottom: "15px" }}
            />
          </a>
          <br />
          <a href="/" target="_blank" rel="noopener noreferrer">
            <img
              src="https://static.wixstatic.com/media/77a25b_ec2fa92086954799bf72699afde7a666~mv2.png"
              alt="VMKG Logo"
              style={{ width: "160px", marginTop: "10px" }}
            />
          </a>
        </div>

        {/* Column 2 */}
        <div>
          <h4 style={headingStyle}>Policies</h4>
          <a href="/privacy-policy" style={linkStyle}>Privacy Policy</a>
          <br />
          <a href="/terms-conditions" style={linkStyle}>Terms & Conditions</a>
          <br />
          <a href="/Cancellation/Refund Policy" style={linkStyle}>Cancellation / Refund</a>
        </div>

        {/* Column 3 */}
        <div>
          <h4 style={headingStyle}>Get in Touch</h4>
          <p style={textStyle}>
            <strong>WhatsApp: </strong>
            <a
              href="https://wa.me/919619604038"
              target="_blank"
              rel="noopener noreferrer"
              style={linkStyle}
            >
              +91 9619604038
            </a>
          </p>
          <p style={textStyle}>
            <strong>Email: </strong>
            <a href="mailto:reachus@victormanickam.com" style={linkStyle}>
              reachus@victormanickam.com
            </a>
          </p>
          <p style={textStyle}>
            <strong>Office: </strong>
            208-209, NBC Complex, CBD Belapur, Navi Mumbai 400614
          </p>
        </div>
      </div>

      <p
        style={{
          textAlign: "center",
          marginTop: "30px",
          fontSize: "13px",
          color: "#666",
        }}
      >
        © {new Date().getFullYear()} HumanDesign Education Pvt Ltd. All rights reserved.
      </p>
    </footer>
  );
};

// Shared styles
const headingStyle = {
  marginBottom: "12px",
  color: "#396AA9",
  fontSize: "15px",
  fontWeight: "600",
};

const linkStyle = {
  color: "#396AA9",
  textDecoration: "none",
  fontSize: "14px",
  fontWeight: "500",
  display: "inline-block",
  margin: "4px 0",
};

const textStyle = {
  fontSize: "14px",
  color: "#444",
  lineHeight: "1.6",
  margin: "6px 0",
};

export default Footer;
